import { Helmet } from '@dr.pogodin/react-helmet';
import { useAtomValue } from 'jotai';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { documentTitleState } from 'states/app';

const HelmetTitle = () => {
  const { t } = useTranslation();
  const title = useAtomValue(documentTitleState);

  return (
    <Helmet>
      <title>{`${t(title)} | Filebox 2.0 | Swisscom`}</title>
    </Helmet>
  );
};

export default memo(HelmetTitle);
